import React from "react";
import { Card } from "react-bootstrap";
 
function DownloadCard({label,color}) {
  return (
      <Card
        className="text-center shadow-sm"
        style={{
          backgroundColor: color[100], // same greenish-yellow shade
          borderRadius: "8px",
          borderColor:color[800],
          cursor: "pointer",
        //   maxWidth: "300px",
          margin: "20px auto",
          display:"flex",
          height:"100px"
        }}
      >
        <Card.Body style={{display:"flex",padding:0}}>
          <Card.Title className="" style={{ fontWeight: "600",margin:"auto", marginTop:"auto !important" }}>
            {label}
          </Card.Title>
        </Card.Body>
      </Card>
  );
}
 
export default DownloadCard;